module.exports = __webpack_public_path__ + "static/img/topbg.3b32792.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/topbg.png
// module id = DW8A
// module chunks = 5